module.exports = __webpack_public_path__ + "img/lp-JAMA.dce99a91.png";